import initMenu from "./modules/menu";
import './modules/hash';
import './modules/discover-carousel';
import './modules/quote';
import './modules/stories-carousel';
import './modules/fancybox';
import './modules/newsletter-form';
import './modules/what-to-do-carousel';
import initSelects from './modules/selects';
import './modules/post-gallery';
import './modules/posts-listing';
import './modules/favourites';
import './modules/accordion';
import './modules/search-form';
import './modules/iframe';
import './modules/events';
import './modules/file-input';

import '../scss/theme.scss';

jQuery(document).ready( function($) {
    initMenu();
    initSelects();
});